export default function debounce(fn, wait) {
	let timer = null;

	return function() {
		clearTimeout(timer);

		timer = setTimeout(() => { 
			fn()
			timer = null;
		},wait);		
	}
}

